const localStorage = typeof window === 'undefined' ? null : window.localStorage;

export default {
  // eslint-disable-next-line consistent-return
  set(key, value, ttl) {
    if (!localStorage) {
      return null;
    }

    const data = {
      value,
      expirationTime: Date.now() + ttl,
    };

    localStorage.setItem(key, JSON.stringify(data));
  },

  get(key) {
    if (!localStorage) {
      return null;
    }

    const data = JSON.parse(localStorage.getItem(key));

    if (!data) {
      return null;
    }

    if (Date.now() >= data.expirationTime) {
      localStorage.removeItem(key);

      return null;
    }

    return data.value;
  },

  // eslint-disable-next-line consistent-return
  remove(key) {
    if (!localStorage) {
      return null;
    }

    localStorage.removeItem(key);
  },
};
